import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Btn } from "../components/Button";
import {
  deleteUser,
  getAllUsers,
  getUserByDocument,
  updateUser,
} from "../lib/actions";
import { toast } from "sonner";
import {
  UpdateUserModal,
  DeleteConfirmationModal,
} from "../components/modals/Modals";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 80%;
  min-height: 50vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Container2 = styled.div`
  width: 80%;
  min-height: 130vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    color: orange;
  }
  .text-3 {
    color: red;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
  }
  @media (max-width: 40em) {
    width: 90%;
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  p span {
    color: orange;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const Div2 = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 50px;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  button {
    margin: 10px 0;
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 85%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const UserTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 30px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
    color: ${(props) => props.theme.text};
  }

  th {
    background-color: ${(props) => props.theme.body};
    font-weight: bold;
  }

  tr:nth-child(even) {
    background-color: ${(props) => props.theme.bodyRgba};
  }

  tr:hover {
    background-color: ${(props) => props.theme.bodyRgba};
  }

  @media (max-width: 48em) {
    font-size: 14px;
    th,
    td {
      padding: 8px;
    }
  }
`;

const ActionsContainer = styled.div`
  width: auto;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: start;
`;

const Actions = ({ onUpdate, onDelete }) => {
  return (
    <ActionsContainer>
      <Btn onClick={onUpdate}>UPDATE</Btn>
      <Btn onClick={onDelete}>DELETE</Btn>
    </ActionsContainer>
  );
};

const ManageUsers = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [users, setUsers] = useState([]);
  const [user, setUserData] = useState([]);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("userId");
    setIsLoggedIn(!!token); // true if token exists
  }, []);

  useEffect(() => {
    // TODO: Replace this with an actual API call
    const fetchuser = async () => {
      try {
        const raw = localStorage.getItem("userId");
        if (raw) {
          const id = JSON.parse(raw);
          const userData = await getUserByDocument(id);
          setUserData(userData);
          const allUsers = await getAllUsers();
          setUsers(allUsers);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchuser();
  }, []);

  const handleOpenUpdate = (user) => {
    setSelectedUser(user);
    setIsUpdateModalOpen(true);
  };

  const handleOpenDelete = (user) => {
    setSelectedUser(user);
    setIsDeleteModalOpen(true);
  };

  const handleUpdateUser = async (updatedUser) => {
    console.log(updatedUser);
    try {
      await updateUser(updatedUser.userId, updatedUser);
      setIsUpdateModalOpen(false);
      // refetch users
      const allUsers = await getAllUsers();
      setUsers(allUsers);
      toast.success("User updated!");
    } catch (error) {
      toast.error("Error updating user");
    }
  };

  const handleDeleteUser = async (userToDelete) => {
    
    try {
      await deleteUser(userToDelete.$id);
      setIsDeleteModalOpen(false);
      // refetch users
      const allUsers = await getAllUsers();
      setUsers(allUsers);
      toast.success("User deleted!");
    } catch (error) {
      toast.error("Error deleting user");
    }
  };
  return (
    <Section id="users">
      <Navigation />
      {isLoggedIn && user.role === "admin" ? (
        <Container2>
          <Title>Trade Millennia Users</Title>

          <UserTable>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>{user.name ?? "undefined"}</td>
                  <td>{user.email}</td>
                  <td>
                    <Actions
                      onUpdate={() => handleOpenUpdate(user)}
                      onDelete={() => handleOpenDelete(user)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </UserTable>

          {isUpdateModalOpen && selectedUser && (
            <UpdateUserModal
              user={selectedUser}
              onClose={() => setIsUpdateModalOpen(false)}
              onSave={handleUpdateUser}
            />
          )}

          {isDeleteModalOpen && selectedUser && (
            <DeleteConfirmationModal
              user={selectedUser}
              onClose={() => setIsDeleteModalOpen(false)}
              onConfirm={handleDeleteUser}
            />
          )}
          {/* Add your art creation form or component here */}
        </Container2>
      ) : (
        <Container>
          <Div>
            <Title>
              <span>Create Your</span> <span className="text-3">Art</span>
            </Title>
            <p>
              <Link to="/">Home</Link>

              <span> . Create</span>
            </p>
          </Div>

          <Div2>
            <p> Please connect your wallet to view this page </p>
            <Link to="/connect-wallet">
              <button>Connect Wallet</button>
            </Link>
          </Div2>
          <div></div>
        </Container>
      )}

      <Footer />
    </Section>
  );
};

export default ManageUsers;
